import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import Swal from 'sweetalert2';
import ApexCharts from 'apexcharts';
import VueApexCharts from 'vue3-apexcharts';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import i18n, { loadLocaleMessages } from './i18n';

async function bootstrap() {
  // Load default language before mounting
  await loadLocaleMessages(localStorage.getItem('lang') || 'en');

  // Load store subscriptions
  require('@/store/subscribe');

  const app = createApp(App);

  // Global properties
  app.config.globalProperties.$swal = Swal;
  app.config.globalProperties.$apexcharts = ApexCharts;
  app.component('apexchart', VueApexCharts);

  loadFonts();

  // Set the base URL for Axios
  // axios.defaults.baseURL = 'http://localhost:8000/api/';

  // app.config.globalProperties.$getImageUrl = function (imageName) {
  //   return `http://localhost:8000/${imageName}`;
  // };

  axios.defaults.baseURL = 'https://api.mnk.co.tz/api/';
  app.config.globalProperties.$getImageUrl = function (imageName) {
    return `https://api.mnk.co.tz/${imageName}`;
  };

  // Wait until auth attempt finishes
  await store.dispatch('auth/attempt', localStorage.getItem('access_token'));

  // Use plugins and mount app
  app.use(store);
  app.use(router);
  app.use(vuetify);
  app.use(i18n);
  app.mount('#app');
}

// Start the app
bootstrap();
